export default __webpack_public_path__ + "static/img/vogue_test_scene_1_0328.1e22e1a.jpg";